export const generateDataStat = (
  stat: string | undefined | null,
  isSmall: boolean,
  isClient: boolean
) => {
  if (!stat || !isClient) return null;

  return `${stat}${isSmall ? '_mobile' : ''}`;
};
